<template>
    <div>
        <out-put-page
            orientation="landscape"
            class="landscape"
            title="Étude financière
"
        >
            <section class="landscape">
                <h3>
                    CPC Prévisionnel
                </h3>
                <data-table :tables="cpc" :isCpc="true" />
            </section>
        </out-put-page>
    </div>
</template>

<script>
import DataTable from "../components/DataTable";
import OutPutPage from "../components/OutPutPage";
import { isArrayOfZeros } from "@/utils";

export default {
    components: {
        OutPutPage,
        DataTable
    },
    props: {
        outPutData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            cpc: {
                headers: [
                    { title: "DÈSIGNATION", type: "String" },
                    { title: "001", type: "Currency" },
                    { title: "002", type: "Currency" },
                    { title: "003", type: "Currency" },
                    { title: "004", type: "Currency" },
                    { title: "005", type: "Currency" },
                    { title: "006", type: "Currency" },
                    { title: "007", type: "Currency" },
                    { title: "008", type: "Currency" },
                    { title: "009", type: "Currency" },
                    { title: "010", type: "Currency" }
                ],
                data: []
            }
        };
    },
    mounted() {
        const cpc = [
            {
                title: "Chiffre d’Affaires",
                key: "chifreAffaire"
            },
            {
                title: "Achats HT",
                key: "achatsPrevisionnel"
            },
            {
                title: "Marge Brute",
                key: "margeBrute"
            },
            {
                title: "Autres charges externes",
                key: "chargeExtern"
            },
            {
                title: "Valeur Ajoutée",
                key: "valeurAjouter"
            },
            {
                title: "Salaires brut",
                key: "salaireBruteSalarier"
            },
            {
                title: "Charges sociales",
                key: "chargeSociales"
            },
            {
                title: "Impôts et taxes",
                key: "impotEtTax"
            },
            {
                title: "Excédent Brut d’Exploitation",
                key: "excedentBrutExploitation"
            },
            {
                title: "Dotations aux amortissements",
                key: "dotationAuxAmortissements"
            },
            {
                title: "Résultat Brut d’Exploitation",
                key: "resultatBrutExploitationA"
            },
            {
                title: "Charges financières",
                key: "chargeFinancieres"
            },
            {
                title: "Résultat financier",
                key: "resultatFinancierB"
            },
            {
                title: "Résultat courant",
                key: "resultatCourant"
            },
            {
                title: "Produits non courants",
                key: "produitNonCourant"
            },
            {
                title: "Résultat non courant",
                key: "resultatNonCourant"
            },
            {
                title: "Résultat Avant Impôts",
                key: "resultatAvantImpot"
            },
            {
                title: "Impôts sur les sociétés",
                key: "impotSurLeRenenu"
            },
            {
                title: "Résultat Net",
                key: "resultatNet"
            },
            {
                title: "Capacité d’Autofinancement/(ou Cash-Flow)",
                key: "cashFlow"
            }
        ];
        let cpcCounter = 0;
        cpc.forEach(elem => {
            if (isArrayOfZeros(this.outPutData.cpc, `${elem.key}`)) return;
            this.cpc.data.push([`${elem.title}`]);
            this.outPutData.cpc.forEach(item => {
                this.cpc.data[cpcCounter].push(item[`${elem.key}`]);
            });
            cpcCounter++;
        });
    }
};
</script>

<style>
@media print {
    .landscape {
        /* position: absolute; */
        /* top: 50%; */
        /* left: 50%; */
        transform: translate(-300px, 0px) rotate(0.75turn);
    }
}
</style>
